import React from "react";
import banner from "../../assets/Svg/mobile-banner-bg.svg";
import bannerSubBg from "../../assets/Svg/banner-subT-bg.svg";
import truckIcon from "../../assets/images/truck-icon-banner.png";
import { useTranslation } from "react-i18next";
const MobileBanner = ({ setOpenSheet }) => {
  const { t } = useTranslation();
  return (
    <div
      className="relative flex lg:hidden h-24 xs:h-[70px] sm:h-20 md:h-24 w-full rounded-2xl flex-col items-start justify-start px-3 my-2 mb-3"
      onClick={() => setOpenSheet(true)}
      style={{
        cursor: "pointer",
        backgroundImage: `url(${banner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className=" gap-2 rounded-lg w-full h-full justify-between items-center flex">
        <div className="flex flex-col justify-center items-start gap-2">
          <p className="w-full text-left text-xs sm:text-sm font-medium text-black">
            {t("banners.mobileBanner.title")}
          </p>
          <div className="w-[90%] xs:w-[80%] sm:w-full flex items-center justify-start relative">
            <img
              className="w-full object-contain"
              src={bannerSubBg}
              alt="bannerSubBg"
            />
            <p className="absolute left-2 sm:left-4 w-full text-left text-[9px] xs:text-[10px] sm:text-xs font-medium text-white px-4">
              {t("banners.mobileBanner.subTitle")}
            </p>
            <img
              src={truckIcon}
              alt="truck"
              className="w-6 h-6 sm:w-8 sm:h-8 -left-1 absolute"
            />
          </div>
        </div>
        {/* <img
          src={rightArrow}
          alt="rightArrow"
          className="sm:w-8 sm:h-8 h-6 w-6"
        /> */}
      </div>
    </div>
  );
};

export default MobileBanner;
